import { type FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import { TradeBenefitsTierProgressionTiles } from './TradeBenefitsTierProgressionTiles.tsx';

import styles from './TradeBenefitsTierProgression.scss';
import dibsCss from 'dibs-css';

const TradeBenefitsTierProgression: FC = () => {
    return (
        <div className={styles.container}>
            <HeadingLevel>
                {Heading => (
                    <>
                        <Heading
                            className={classnames(
                                styles.title,
                                dibsCss.sassyFontHeaderXLarge,
                                dibsCss.m0
                            )}
                        >
                            <FormattedMessage
                                id="abt.TradeBenefitsTierProgression.title"
                                defaultMessage="<italic>Shop</italic> on 1stDibs.{br} <italic>Earn</italic> Points.{br} <italic>Unlock</italic> More Benefits."
                                values={{
                                    br: <br className={styles.mobileBreak} />,
                                    italic: content => (
                                        <span className={dibsCss.sassyFontHeaderXLargeItalic}>
                                            {content}
                                        </span>
                                    ),
                                }}
                            />
                        </Heading>
                        <TradeBenefitsTierProgressionTiles />
                    </>
                )}
            </HeadingLevel>
        </div>
    );
};

export { TradeBenefitsTierProgression };
